import styled from "styled-components";

// Main container for all pages
export const MainContainer = styled.section`
  width: 100%;
  height: 100%;
  padding: 4rem 0rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding: 2rem 1rem; /* Reduce padding for smaller screens */
  }
`;

// Hero section used across pages
export const HeroSection = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 4rem 2rem;
  background-color: #fff;
  width: 100%;
`;

export const HeroTitle = styled.h1`
  font-family: "Montserrat", sans-serif;
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #333;
`;

export const HeroSubtitle = styled.p`
  font-family: "Montserrat", sans-serif;
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
  max-width: 1200px;
  width: 100%;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
  }
`;

export const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const DocumentationParagrah = styled.section`
  width: 80%;
  height: 100%;
  padding: 4rem 2rem; /* Add padding on the sides for a cleaner layout */
  display: flex;
  flex-direction: column;
  justify-content: flex-start; /* Aligns content to the top */
  align-items: flex-start; /* Align text to the left */

  h1 {
    font-size: 1.5rem; /* Make h1 larger than other headings */
    font-weight: bold;
    margin-bottom: 2rem; /* Add more space below h1 */
    color: #2c3e50; /* Dark blue-gray for strong contrast */
    text-align: left; /* Ensures it stays aligned with the rest of the text */
    border-bottom: 4px solid #f5b041; /* Add an underline effect with the primary theme color */
    padding-bottom: 0.5rem; /* Add space for a cleaner look */
  }

  h2,
  h3,
  p {
    margin-bottom: 1.5rem; /* Add space between elements */
    line-height: 1.6; /* Improve readability by increasing line height */
  }

  ul {
    margin-left: 2rem; /* Indent lists for clarity */
    margin-bottom: 1.5rem;
    list-style-type: disc; /* Adds bullet points */
  }

  ol {
    margin-left: 2rem; /* Indent lists for clarity */
    margin-bottom: 1.5rem;
    list-style-type: decimal; /* Ensures numbers show */
  }

  li {
    margin-bottom: 0.8rem; /* Add space between list items */
  }

  a {
    color: #4caf50; /* Custom link color */
    text-decoration: underline;
  }

  button {
    margin-top: 1.5rem; /* Add space above buttons */
  }

  @media (max-width: 768px) {
    padding: 1rem; /* Reduce padding on smaller screens */
  }

  @media (max-width: 480px) {
    padding: 0.5rem; /* Compact padding for phones */
  }
`;
